import { Sparkles } from 'lucide-react'
import automaisLogo from '../../img/mais_logo_hd.png'

export default function TerminalAIButton({ onClick, hasConversation }) {
  return (
    <button
      onClick={onClick}
      title="Agente AI"
      className="absolute top-4 right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-theme-primary text-white shadow-lg transition-all hover:bg-theme-primary/90 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-theme-primary focus:ring-offset-2 focus:ring-offset-slate-900 overflow-hidden"
    >
      <img
        src={automaisLogo}
        alt="Automais"
        className="absolute inset-0 w-full h-full object-cover opacity-60 rounded-full"
      />
      <Sparkles className="relative z-10 h-5 w-5 text-white drop-shadow-md" />
      {hasConversation && (
        <span className="absolute -top-0.5 -right-0.5 h-3 w-3 rounded-full bg-emerald-400 ring-2 ring-slate-900 z-20" />
      )}
    </button>
  )
}
